import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';
import { ConfirmationType } from '../models/confirmation';

export const confirmationReducer = (
  state: ConfirmationType,
  action: ActionType
): ConfirmationType => {
  switch (action.type) {
    case Actions.ShowConfirmation:
      return {
        open: true,
        title: action.payload.title,
        text: action.payload.text,
        agreeAction: action.payload.agreeAction,
        params: action.payload.params
      };
    case Actions.HideConfirmation:
      return { open: false, title: null, text: null };
    default:
      return state;
  }
};
